import { routes } from "src/shared/routes";
import { TTeamConfig } from "src/shared/types/teamConfig.types";
import { FAQS } from "./helper";
import logoImage from "public/images/reno_aces/Reno-Aces_2.png";

// s3 logo url : https://ss-leagues.s3.amazonaws.com/Minor%20League%20Baseball/Reno-Aces_2.svg

export const renoaces_pass_sandbox: TTeamConfig = {
  TEAM_SCHEMA: "renoaces_pass_sandbox",
  TEAM_FULL_NAME: "Renos Aces",
  BROWSER_TITLE: "Aces Ballpark Pass",
  CLIENT_ID: "",
  VENDOR: "TDC",

  TEAM_GLOBAL_SETTINGS: {
    COLORS_PRIMARY: "#002a5c",
    COLORS_SECONDARY: "#d31145",
    LOGOUT_ON_INVALID_SESSION: false,
    DEFAULT_APP_ROUTE: routes.landing,
  },

  LANDING_PAGE_SETTINGS: {
    PASS_BANNER: {
      PASS_DISPLAY_MODE: "separate",
    },
  },

  HOME_PAGE_SETTINGS: {
    EVENT_CARD: {
      SHOW_SINGLE_GAMES_IN_COLLAPSE: true,
    },
  },

  GROUP_INVITE_PAGE_SETTINGS: {
    PASS_BANNER: {
      DISABLE_BACKGROUND_IMAGE_FILTER: true,
      PASS_DISPLAY_MODE: "separate",
    },
  },

  CHECKOUT_PAGE_SETTINGS: {
    CHECKOUT_FORM: {
      SAVE_CARD_SWITCH_ENABLED: false,
    },
  },

  MANAGE_SUBSCRIPTION_PAGE_SETTINGS: {
    ZERO_STATE: {
      OPT_OUT_EARLIEST_DATE: new Date("10/01/2024"),
    },
  },

  IMAGES: {
    LOGO_URL: `${logoImage.src}?width=96&height=69`,
  },

  LANGUAGES: {
    FAQS: FAQS,
  },
};
